import React from 'react'


const ExchangeIcon = () => {


    return (
        <>
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 35 35" fill="none" className="cursor-pointer">
                <path d="M2 8.2L7.49289 2.70711C7.88342 2.31658 8.51658 2.31658 8.9071 2.70711L14.4 8.2" stroke="white" stroke-width="3" stroke-linecap="round" />
                <path d="M8.19971 4.06679L8.19971 28.8668" stroke="white" stroke-width="3" stroke-linecap="round" />
                <path d="M20.6001 26.8L26.093 32.2929C26.4835 32.6834 27.1167 32.6834 27.5072 32.2929L33.0001 26.8" stroke="white" stroke-width="3" stroke-linecap="round" />
                <path d="M26.7998 30.9332L26.7998 6.13321" stroke="white" stroke-width="3" stroke-linecap="round" />
            </svg>
        </>
    );
}

export default ExchangeIcon